/* @flow */
import * as ActionTypes from '../actions';

type State = {isFetching: boolean, logged: boolean};

const loginStatus = (state: State = { isFetching: false, logged: false }, action: any) => {
  switch (action.type) {
    case ActionTypes.VERIFY_REQUEST:
      return {
        ...state,
        isFetching: true,
        isFailure: false,
      };
    case ActionTypes.VERIFY_SUCCESS:
      return {
        ...state,
        verified: true,
        isFailure: false,
        isFetching: false
      };
    case ActionTypes.VERIFY_FAILURE:
      return {
        ...state,
        verified: false,
        isFailure: true,
        isFetching: false
      };
    default:
      return state;
  }
};

export default loginStatus;



/** WEBPACK FOOTER **
 ** ./src/reducers/verifyStatus.js
 **/